export const AppointmentAnalyticsQueryKeys = {
  base: ['appointmentAnalytics'] as const,

  charts: (query?: string) => [...AppointmentAnalyticsQueryKeys.base, 'charts', query],
  report: (query?: string) => [...AppointmentAnalyticsQueryKeys.base, 'report', query],
};
